// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TU22","index":"styles_index__2gH6n"};